export const TRANSACTION_STATUSES_ARRAY: Readonly<
  { id: number; name: string }[]
> = [
  { id: 1, name: "Redeemed" },
  { id: 7, name: "Earned" },
  { id: 3, name: "Cancelled" },
  { id: 5, name: "Failed" },
  { id: 4, name: "Expired" },
  { id: 2, name: "Used" },
  { id: 6, name: "Pending" },
];

export const TRANSACTION_STATUSES: Readonly<Record<number, string>> =
  TRANSACTION_STATUSES_ARRAY.reduce(
    (acc, status) => ({ ...acc, [status.id]: status.name }),
    {},
  );

export const TABLE_PAGE_SIZE = 14;
